import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const isAppShell = location.pathname === '/app';

  return (
    <div className="min-h-screen flex flex-col bg-cream">
      {!isAppShell && <Navbar />}
      <div className="flex-1">{children}</div>
      {!isAppShell && <Footer />}
    </div>
  );
}
